import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
const VideoOverlay = ({isVisible, setVisible}) => {
  const isYoutube = isVisible?.toLowerCase().includes("youtube.com");
  useEffect(() => {
    window.addEventListener("keydown", keyEvent);

    return () => {
      window.removeEventListener("keydown", keyEvent);
    }
  }, [])
  const onOverlayClick = (e) => {
    setVisible(null); 
  }

  const keyEvent = (e) => {
    if(e.key === "Escape") {
      setVisible(null);
    }
  }
  const queryParams = isVisible?.includes("?") ? '&autoplay=1' : '?autoplay=1';

  if(isVisible) {
    return ReactDOM.createPortal(<div className="z-10 fixed inset-0 w-full h-full bg-black bg-opacity-90" onClick={onOverlayClick}>
      <div className="video-container">
        <div className="video-overlay flex items-center video-responsive-2">
          {isYoutube ? 
          <iframe width="640" height="360" src={isVisible} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> :
          <iframe src={`${isVisible}${queryParams}`} allow="autoplay" width="640" height="360" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        }
        </div>
      </div>
    </div>,document.body)
  }
  return null;
}

export default VideoOverlay;